export enum OrderStatus {
    closed = "closed",
    open = "opened"
}
